import { render, staticRenderFns } from "./EnvelopeParent.vue?vue&type=template&id=255e91c8&scoped=true&"
import script from "./EnvelopeParent.vue?vue&type=script&setup=true&lang=ts&"
export * from "./EnvelopeParent.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255e91c8",
  null
  
)

export default component.exports